export default __webpack_public_path__ + "static/media/metal_highlight.c20274d1.png";